export const SOCIAL_LOGIN_PLATFORMS = {
  GOOGLE: "Google",
};
export const ERROR_STATUS_CODE = {
  EMAIL_VERIFIED_ERROR: "alg_wc_ev_email_verified_error",
  INCORRECT_PASSWORD: "incorrect_password",
  INVALID_EMAIL: "invalid_email",
  NOT_VERIFIED_ACCOUNT: "40101",
};

export const PAGES = {
  CONTACT_US: "/contact",
  STORIES: "/stories",
  CONTACT_SUBMITTED: "/contact-submitted",
  UNSUBSCRIBE: "/unsubscribe",
  POLICY: "/privacy-policy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  LOGIN: "/sign-in",
  LOGOUT: "/logout",
  REGISTER: "/sign-up",
  FORGOT_PASSWORD: "/forgot-password",
  DASHBOARD: "/dashboard",
  SURVEY: "/survey",
  SELECT_PACKAGES: "/select-packages",
  SELECT_STYLES: "/select-styles",
  KEY_FEATURES: "/key-features",
  UPLOAD_TIPS: "/upload-tips",
  UPLOAD_PHOTOS: "/upload-photos",
  COMPLETED: "/completed",
  VIEW_RESULTS: "/results",
  RESULT_DETAIL: "/result-detail",
  EMAIL_CONFIRMATION: "/email-confirmation",
  SEND_EMAIL_VERIFICATION: "/send-email-confirmation",
  PAYMENT_SUCCESSFUL: "/payment-successful",
  PAYMENT_CANCELLED: "/payment-cancelled",
  SHARED: "/shared",
  VOTES: "/votes",
  PROFILE: "/profile",
};

const authPages = {
  LOGIN: `/p${PAGES.LOGIN}`,
  REGISTER: `/p${PAGES.REGISTER}`,
  FORGOT_PASSWORD: `/p${PAGES.FORGOT_PASSWORD}`,
  EMAIL_CONFIRMATION: `/p${PAGES.EMAIL_CONFIRMATION}`,
  SEND_EMAIL_VERIFICATION: `/p${PAGES.SEND_EMAIL_VERIFICATION}`,
  LOGOUT: PAGES.LOGOUT,
};

export const PAGE_URLS = {
  ...authPages,
};

export const QUERY_MOBILE = "62em";
export const QUERY_TABLET = "40em";

export const BETTERSHOT_MAILTO_ADDRESS = "mailto:hello@bettershot.ai";
